module.exports = __webpack_public_path__ + "225499c95c4328077fcb61927f45e33b.svg";